import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { INotificationStats } from "../models/notifications/Notifications";

export default function useNotificationStats(loading: boolean = false) {
  const { get, put, getFile } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 2.5; // 2.5 minutes

  const notifications = useQuery({
    queryKey: ["notifications"],
    queryFn: () => get<DefaultResponseWithData<INotificationStats>>(`/stats/notifications`),
    staleTime,
    enabled: !loading
  });

  return {
    notifications
  };
}
